(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function initTransparentHeader() {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    const mainContent = document.getElementById('MainContent');
    const firstSection = mainContent && mainContent.firstElementChild;
    const heroSection = firstSection && firstSection.querySelector('[data-enable-transparent-header]');

    if (!heroSection || heroSection.dataset.enableTransparentHeader !== 'true') return;

    headerWrapper.classList.add('header-wrapper--transparent-capable');

    // The announcement bar stays in normal document flow (see the CSS
    // comment above `.shopify-section-group-header-group:has(...)`), so as
    // the page scrolls it moves up like any other content while the fixed
    // header's `top` offset does not — measuring its height once (as before)
    // left that height as a permanent gap above the fixed header once the
    // announcement bar had scrolled out of view entirely. Using its
    // bottom edge (clamped to 0) instead re-measures on every scroll, so the
    // offset shrinks in lockstep and hits 0 exactly when the announcement
    // bar leaves the viewport — the header then sits flush at the top with
    // no gap, same as it would with native `position: sticky` (unusable
    // here since the header must be removed from flow to overlay the hero).
    const announcementBar = document.querySelector('.announcement-bar-section');
    let announcementOffsetUpdateQueued = false;
    const updateAnnouncementOffset = () => {
      announcementOffsetUpdateQueued = false;
      const offset = announcementBar ? Math.max(0, announcementBar.getBoundingClientRect().bottom) : 0;
      document.documentElement.style.setProperty('--announcement-bar-height', `${offset}px`);
    };
    const queueAnnouncementOffsetUpdate = () => {
      if (announcementOffsetUpdateQueued) return;
      announcementOffsetUpdateQueued = true;
      requestAnimationFrame(updateAnnouncementOffset);
    };
    updateAnnouncementOffset();
    if (announcementBar) {
      if ('ResizeObserver' in window) new ResizeObserver(queueAnnouncementOffsetUpdate).observe(announcementBar);
      window.addEventListener('scroll', queueAnnouncementOffsetUpdate, { passive: true });
    }

    const defaultSchemeClass = headerWrapper.dataset.defaultSchemeClass;
    const transparentSchemeClass = headerWrapper.dataset.transparentSchemeClass;

    const setTransparent = (isTransparent) => {
      headerWrapper.classList.toggle('header-wrapper--transparent-active', isTransparent);

      if (transparentSchemeClass && defaultSchemeClass && transparentSchemeClass !== defaultSchemeClass) {
        headerWrapper.classList.toggle(transparentSchemeClass, isTransparent);
        headerWrapper.classList.toggle(defaultSchemeClass, !isTransparent);
      }
    };

    const observer = new IntersectionObserver((entries) => setTransparent(entries[0].isIntersecting), {
      rootMargin: `-${headerWrapper.offsetHeight}px 0px 0px 0px`,
    });

    observer.observe(heroSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTransparentHeader);
  } else {
    initTransparentHeader();
  }

  } catch(e) { console.error(e); }
})();
})();
